/**
 * Featured Collection 无限加载
 *
 * 每个加载器仅从自身 Section 的下一页响应中提取商品，避免 Header、
 * Mega Menu 或其他 Featured Collection 的 .product-block 被误追加。
 */
(function () {
  const managerKey = '__featuredCollectionLoadMoreManager__';
  const containerSelector = '.load-more-container[data-section-id]';

  if (window[managerKey]?.initialized) return;

  const manager = {
    initialized: true,
    init(root = document) {
      addSpinnerStyles();

      const containers = [];
      if (root.matches?.(containerSelector)) containers.push(root);
      root.querySelectorAll?.(containerSelector).forEach((container) => {
        containers.push(container);
      });

      containers.forEach(setupLoadMore);
    },
  };

  window[managerKey] = manager;

  function addSpinnerStyles() {
    if (document.getElementById('load-more-styles')) return;

    const style = document.createElement('style');
    style.id = 'load-more-styles';
    style.textContent = `
      @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
      }
    `;
    document.head.appendChild(style);
  }

  function escapeCssIdentifier(value) {
    if (window.CSS?.escape) return window.CSS.escape(value);
    return value.replace(/[^a-zA-Z0-9_-]/g, '\\$&');
  }

  function findSection(documentRoot, sectionId) {
    return documentRoot.querySelector(
      `.section-id-${escapeCssIdentifier(sectionId)}`,
    );
  }

  function setupLoadMore(container) {
    if (container.dataset.loadMoreInitialized === 'true') return;

    const sectionId = container.dataset.sectionId;
    const section = container.closest('.collection-slider-row');
    const productGrid = section?.querySelector('.product-grid');
    const nextPageLink = section?.querySelector('.next-page-url');

    if (!sectionId || !section || !productGrid || !nextPageLink) {
      container.style.display = 'none';
      return;
    }

    container.dataset.loadMoreInitialized = 'true';

    let isLoading = false;
    let hasMore = true;
    let observer;

    function stopLoading() {
      hasMore = false;
      container.style.display = 'none';
      observer?.unobserve(container);
    }

    function getNextPageUrl() {
      return nextPageLink.dataset.nextPageUrl || nextPageLink.getAttribute('href');
    }

    async function loadMoreProducts() {
      if (isLoading || !hasMore) return;

      const nextPageUrl = getNextPageUrl();
      if (!nextPageUrl) {
        stopLoading();
        return;
      }

      isLoading = true;
      const spinner = container.querySelector('.load-more-spinner');
      if (spinner) spinner.style.display = 'flex';

      try {
        const response = await fetch(nextPageUrl, {
          credentials: 'same-origin',
        });
        if (!response.ok) {
          throw new Error(`网络响应错误: ${response.status}`);
        }

        const html = await response.text();
        const responseDocument = new DOMParser().parseFromString(
          html,
          'text/html',
        );
        const responseSection = findSection(responseDocument, sectionId);
        const responseGrid = responseSection?.querySelector('.product-grid');

        if (!responseSection || !responseGrid) {
          throw new Error(`未找到对应的 Featured Collection Section: ${sectionId}`);
        }

        const newProducts = Array.from(responseGrid.children).filter((element) =>
          element.classList.contains('product-block'),
        );

        if (newProducts.length === 0) {
          stopLoading();
          return;
        }

        const fragment = document.createDocumentFragment();
        newProducts.forEach((product) => {
          fragment.appendChild(product.cloneNode(true));
        });
        productGrid.appendChild(fragment);

        const responseNextPageLink =
          responseSection.querySelector('.next-page-url');

        if (responseNextPageLink?.dataset.nextPageUrl) {
          nextPageLink.dataset.nextPageUrl =
            responseNextPageLink.dataset.nextPageUrl;
          nextPageLink.href = responseNextPageLink.dataset.nextPageUrl;
        } else {
          stopLoading();
        }
      } catch (error) {
        hasMore = false;
        observer?.unobserve(container);
        container.innerHTML =
          '<div class="text-center">加载失败，请刷新页面重试</div>';
      } finally {
        isLoading = false;
        if (spinner?.isConnected) spinner.style.display = 'none';
      }
    }

    observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && hasMore && !isLoading) {
            loadMoreProducts();
          }
        });
      },
      {
        rootMargin: '300px',
        threshold: 0.01,
      },
    );

    observer.observe(container);

    container.addEventListener('click', () => {
      if (!isLoading && hasMore) loadMoreProducts();
    });

    container.__featuredCollectionLoadMoreCleanup = () => {
      hasMore = false;
      observer.disconnect();
    };
  }

  function init() {
    manager.init(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    manager.init(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll?.(containerSelector).forEach((container) => {
      container.__featuredCollectionLoadMoreCleanup?.();
    });
  });
})();
